import styled, { css } from 'styled-components';
import React from 'react';

const Text = styled.div<{ small?: boolean }>`
  line-height: 30px;
  ${({ small, theme }) =>
    small
      ? css`
          font-size: 16px;
        `
      : css`
          font-size: 24px;

          ${theme.button.font}
        `}
`;

const SubText = styled.div`
  line-height: 18px;
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const flatButtonSizeMixin = css<{ small?: boolean }>`
  ${({ small, theme }) =>
    small
      ? css`
          height: 40px;
          border-radius: ${theme.borderRadius.sm};
        `
      : css`
          height: 76px;
          border-radius: ${theme.borderRadius.md};
        `}

  padding-left: 16px;
  padding-right: 16px;
  width: 100%;

  cursor: pointer;

  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    min-width: 0px;
  }
`;

const Tip = styled.i``;

const FlatButton = styled(
  ({
    className,
    withTip,
    small,
    children,
    onClick,
    reverse,
  }: {
    className?: string;
    withTip?: boolean;
    small?: boolean;
    children: string | { text: string; subtext: string };
    onClick?: () => void;
    reverse?: boolean;
  }) => {
    const { text, subtext } = typeof children === 'string' ? { text: children, subtext: null } : children;
    return (
      <div className={className} role="button" tabIndex={0} onClick={onClick} onKeyPress={onClick}>
        <div>
          {subtext && reverse && <SubText>{subtext}</SubText>}
          <Text small={small}>{text}</Text>
          {subtext && !reverse && <SubText>{subtext}</SubText>}
        </div>
        {withTip && <Tip className="fa fa-angle-right" />}
      </div>
    );
  },
)<{ primary?: boolean; secondary?: boolean; small?: boolean; withTip?: boolean }>`
  ${flatButtonSizeMixin}

  ${({ primary }) =>
    primary &&
    css`
      background: ${({ theme }) => theme.button.background.cta};
      color: #ffffff;
    `}

  ${({ secondary }) =>
    secondary &&
    css`
      background: ${({ theme }) => theme.button.color.muted};
    `}

  ${Tip} {
    transition: transform 0.3s;
  }

  :hover {
    opacity: ${({ theme }) => theme.button.opacity.hover};
    ${Tip} {
      transform: translateX(3px);
    }
  }
`;

const FlatButtonFake = styled.div`
  ${({ theme }) => theme.fake.default}
  ${flatButtonSizeMixin}
`;

export default FlatButton;
export { Text, SubText, FlatButtonFake };
